module.exports = __webpack_public_path__ + "img/icon-globe.b5f7c984.svg";